// extracted by mini-css-extract-plugin
export default {"container":"Qp-z","heading":"Rp-z","text":"Sp-z","info":"Tp-z","link":"Up-z","fullMaxWidth":"Vp-z"};